import type { Theme } from '@mui/material/styles';

// Emoji drawn in Google's style for everyone (Windows and Mac alike), from the
// Noto Color Emoji web font loaded in index.html. It goes AFTER the text font:
// letters and digits stay in the app font, emoji fall through to Noto.
export const emojiFontFamily = (theme: Theme) => `${theme.typography.fontFamily}, 'Noto Color Emoji'`;

const EMOJI_ONLY =
    /^(?:\p{Extended_Pictographic}|\p{Emoji_Component}|\p{Emoji_Modifier}|\u200d|\ufe0f|\s)+$/u;
const MAX_BIG = 3;

type SegmenterCtor = new () => { segment(input: string): Iterable<unknown> };

/** 1–3 emoji and nothing else → shown large, like WhatsApp. */
export const bigEmojiCount = (text: string | null | undefined): number => {
    const trimmed = text?.trim();
    if (!trimmed || !EMOJI_ONLY.test(trimmed) || !/\p{Extended_Pictographic}/u.test(trimmed)) return 0;
    // Counts 👍🏽 or 👨‍👩‍👧 as one emoji. Intl.Segmenter is in every current browser
    // but missing from this project's TS lib, hence the local type.
    const Segmenter = (Intl as unknown as { Segmenter?: SegmenterCtor }).Segmenter;
    const compact = trimmed.replace(/\s+/g, '');
    const count = Segmenter ? [...new Segmenter().segment(compact)].length : [...compact].length;
    return count <= MAX_BIG ? count : 0;
};
